<template>
  <div class="step-container">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-container">
          <div class="step-icon step-icon-active step-icon-active-personal-information"></div>
          <h6>Personal Information</h6>
        </div>
        <personal-information-form />
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="title-container">
          <div class="step-icon step-icon-active step-icon-active-retirement-information"></div>
          <h6>Retirement Information</h6>
        </div>
        <retirement-information-form />
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="title-container">
          <div class="step-icon step-icon-active step-icon-active-career-progression"></div>
          <h6>Career Information</h6>
        </div>
        <career-progression-table />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 buttons">
        <button type="button" class="btn btn-primary" @click="recalculate" :disabled="!canContinue">
          Recalculate
          <i class="fa fa-caret-right" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ChangeOptionsMixin from '@/js/mixins/calculator/results/change-options/change-options-mixin';

import PersonalInformationForm from '../../personal-information/personal-information-form';
import RetirementInformationForm from '../../retirement-information/retirement-information-form';
import CareerProgressionTable from '../../career-progression/career-progression-table';

export default {
  mixins: [ChangeOptionsMixin],

  components: {
    'personal-information-form': PersonalInformationForm,
    'retirement-information-form': RetirementInformationForm,
    'career-progression-table': CareerProgressionTable,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/resources';

.buttons {
  text-align: right;
}

.step-container {
  background-color: $wizard-step-bg;
}

.title-container {
  height: 52px;
}

h6 {
  margin-top: 10px;
  margin-left: 10px;
}

hr {
  background-color: $brand-primary;
  height: 1px;
  margin: 10px 0;

  border: solid #ddd;
  border-width: 1px 0 0;
}
</style>
